"use strict";function scanCard$(d){return ddSdk_1.ddSdk.invokeAPI(apiName,d)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.scanCard$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.util.scanCard";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"2.8.0"},_a[ddSdk_1.ENV_ENUM.android]={vs:"2.8.0"},_a)),exports.scanCard$=scanCard$,exports.default=scanCard$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/util/scanCard.js
// module id = 1023
// module chunks = 106